export const environment = {
    production: false,
    envName: 'staging',
    serverUrl: 'https://commerce-api-staging-us.sec3ure.com',
    zuoraUrl: 'https://apisandbox.zuora.com/apps/PublicHostedPageLite.do'
  };
